define('controllers/Podio.Controllers.DynamicContentManager',['require','jquery','underscore','lib/backbone/Backbone.PodioController','views/lib/Podio.Views.ContentOverlay','lib/backbone/Backbone.Mixins.StateMachine','lib/Podio.Event','lib/GlobalEventBus','lib/Podio.Config','bowser','lib/Podio.DynamicContentRoutes'],function(require) {

  var $ = require('jquery');
  var _ = require('underscore');
  var PodioController = require('lib/backbone/Backbone.PodioController');
  var ViewContentOverlay = require('views/lib/Podio.Views.ContentOverlay');

  var BackboneMixinStateMachine = require('lib/backbone/Backbone.Mixins.StateMachine');

  var podioEvent = require('lib/Podio.Event');
  var globalEvent = require('lib/GlobalEventBus');
  var podioConfig = require('lib/Podio.Config');
  var browser = require('bowser');
  var dynamicRoutes = require('lib/Podio.DynamicContentRoutes');

  var controller = PodioController.extend({
    ANIMATION_TYPES: {
      shiftLeft: 'animation-shift-to-left',
      shiftRight: 'animation-shift-to-right'
    },
    states: ['content-replacement', 'overlay'],
    enterState: {
      'content-replacement': 'enterReplacement',
      'overlay': 'enterOverlay'
    },
    leaveState: {
      'start': 'leaveStart',
      'content-replacement': 'leaveReplacement',
      'overlay': 'leaveOverlay'
    },

    initialize: function(options) {
      _.bindAll(this, '_onBundleLoaded', 'onOverlayClosed');

      this.bundleMap = this._getBundleMap();
      this.moduleLoaded = new $.Deferred();

      this._super();

      this._initOptions(options);
      this._bindEvents();
    },

    _bindEvents: function() {
      this.listenTo(this.eventBus, 'overlayView:closed', this.onOverlayClosing);
      this.listenTo(this.eventBus, 'overlayView:prevTriggered', this.onOverlayPrevNextTriggered.curry('prev'));
      this.listenTo(this.eventBus, 'overlayView:nextTriggered', this.onOverlayPrevNextTriggered.curry('next'));
    },

    _initOptions: function(options) {
      this.navigator = options.navigatorDelegate;
    },

    _getBundleMap: function() {
      return dynamicRoutes;
    },

    _getRenderType: function(renderType) {
      // default ist content-replacement, when entering a brand new page
      this.currentRenderType = this.currentRenderType || renderType || 'content-replacement';
      return this.currentRenderType;
    },

    _constructDelegate: function(permalink, sourceDelegate) {
      var self = this;

      this.bundleDelegate = {
        navigateBack: function() {
          self.navigator.navigateTo(self.returnURL);
        },
        closeOverlay: function() {
          self.closeOverlay();
        },
        updateArrows: function(id) {
          var options = self.currentOverlayOptions;

          if (options && options.itemNavigationDelegate) {
            if (_.isDefined(id)) {
              options.itemNavigationDelegate.updateIndex(id);
            } else {
              options.itemNavigationDelegate.resetIndex();
            }

            self._handleOptions(options);
          }
        },
        hideArrows: function() {
          if (self.overlayView && typeof self.overlayView.updateNextPrevNavigation === 'function') {
            self.overlayView.updateNextPrevNavigation({
              enablePrev: false,
              enableNext: false
            });
          }
        },
        showArrows: function() {
          var options = self.currentOverlayOptions;

          self._handleOptions(options);
        },
        isOnPermalink: permalink
      };

      if (_.isDefined(sourceDelegate)) {
        _.extend(this.bundleDelegate, sourceDelegate);
      }
    },

    _sameBundleAndSection: function(bundle, section) {
      return this.currentBundle === 'bundles/' + bundle && this.currentSection === section;
    },

    loadContent: function(options) {
      var bundleData = this.bundleMap[options.routeData.pattern];

      this.contentOptions = options;

      this._constructDelegate(options.permalink, options.sourceDelegate);

      // don't do anything if we are trying to load
      // the same bundle and section that is already loaded
      if (!this._sameBundleAndSection(bundleData.bundle, bundleData.section)) {
        this.toState(this._getRenderType(options.renderType), null, options);
      }
    },

    handleUnsupportedContent: function(options) {
      if (options.fromPopState && _.isFunction(this.shouldClose)) {
        return this.shouldClose(true).done(this.toState.bind(this, 'start')).fail(function() {
          history.pushState({ dynamic: true }, '', options.prevURL);
        });
      } else {
        // will trigger leave callback for the current state
        this.toState('start');

        return (new $.Deferred()).resolve();
      }
    },

    leaveStart: function(oldState, newStateOptions) {
      this.returnURL = newStateOptions.previousURL || this.returnURL;
    },

    enterReplacement: function(oldState, options) {
      // do not inject CSS if we have entered a brand new page
      // since it's already loaded in the Rails layout
      this._initContent('content-replacement', options.routeData, { noCSS: oldState === 'start' });
    },

    enterOverlay: function(oldState, options) {
      this.currentUrlPattern = options.routeData.pattern;
      this._initContent('overlay', options.routeData);

      if (!this.overlayView) {
        this._renderOverlay(options);
      } else {
        this._handleOptions(options);
      }
    },

    leaveReplacement: function(newStateName) {
      // if we move to unsupported content, reload the page
      if (newStateName === 'start') {
        document.location.reload(true);
      } else {
        this._disposeCurrentContent();
      }
    },

    leaveOverlay: function(newStateName, newOptions) {
      // changing from one overlay to another on the same section, don't destroy
      if (newStateName === 'overlay' && newOptions.routeData.pattern === this.currentUrlPattern) {
        if (this.currentExports.dispose) {
          this.currentExports.dispose();
        }
      } else {
        this._disposeCurrentContent();
        this._disposeContentOverlayInstance();
        this._restoreTitle();
      }
    },

    _initContent: function(renderType, routeData, options) {
      var bundleData = this.bundleMap[routeData.pattern];

      options = options || {};

      // load JS
      this._initJSBundle(bundleData.bundle, routeData.params, this._getRootSelector(bundleData.section));

      // load CSS
      if (!options.noCSS) {
        this._loadCSSSection(bundleData.section);
      }
    },

    _initJSBundle: function(bundle, UrlParams, rootClass) {
      this.currentBundle = 'bundles/' + bundle;
      this.currentModule = require([this.currentBundle], this._onBundleLoaded.curry(UrlParams, rootClass));
    },

    _disposeJSBundle: function() {
      if (this.currentExports) {
        if (this.currentExports.dispose) {
          this.currentExports.dispose();
        }

        this.currentExports.titleUpdatedSignal.removeAll();

        requirejs.undef(this.currentBundle);

        delete this.currentModule;
        delete this.currentExports;
        delete this.currentBundle;
        delete this.shouldClose;
        this.moduleLoaded = new $.Deferred();
      }
    },

    _onBundleLoaded: function(params, rootClass, exports) {
      this.currentExports = exports;
      var self = this;

      exports.init(params, rootClass, this.bundleDelegate);

      exports.titleUpdatedSignal.add(function(title) {
        if (!self.prevDocumentTitle) {
          self.prevDocumentTitle = document.title;
        }
        document.title = title;
      });

      if (exports.shouldClose) {
        this.shouldClose = exports.shouldClose;
      }

      this.moduleLoaded.resolve();
    },

    _getRootSelector: function(section) {
      return '.{0}-section > .body'.format(section);
    },

    _loadCSSSection: function(section) {
      var elmHead = $('head');

      // don't inject a link if we are switching to the same section again
      if ($('link.section' + section).length) {
        return true;
      }

      this.currentSection = section;

      $('<link>', {
        href: this._getStylesheetUrl(section),
        media: 'all',
        rel: 'stylesheet',
        type: 'text/css'
      }).addClass('section-' + section).appendTo(elmHead);
    },

    _getStylesheetUrl: function(stylesheet) {
      var path;

      if (podioConfig.environment === 'development' && !podioConfig.use_bundled_assets) {
        path = '{0}/app/assets/stylesheets/{1}.scss'.format(podioConfig.asset_host, stylesheet);
      } else {
        path = '{0}/stylesheets-visual-refresh{1}/compressed/{2}.css'.format(podioConfig.asset_host, podioConfig.jammit_asset_suffix, stylesheet);
      }

      return path;
    },

    _disposeCSSSection: function() {
      $('head link.section-' + this.currentSection).remove();
      delete this.currentSection;
    },

    _disposeCurrentContent: function() {
      this._disposeJSBundle();
      this._disposeCSSSection();
    },

    _renderOverlay: function(options) {
      if (!this.overlayView) {
        this.overlayView = new ViewContentOverlay({
          contentClassName: this.currentSection + '-section',
          eventBus: this.eventBus
        });

        podioEvent.trigger(podioEvent.Types.overlayOpened);
        globalEvent.trigger('overlay.open');
      }

      this.overlayView.render().elm.appendTo('body');

      this._handleOptions(options);
    },

    _handleOptions: function(options) {
      this.currentOverlayOptions = options;
      var navDelegate = options && options.itemNavigationDelegate;

      if (_.isDefined(navDelegate)) {
        this.overlayView.updateNextPrevNavigation({
          enablePrev: navDelegate.hasPrev(),
          enableNext: navDelegate.hasNext()
        });
      } else if (this.overlayView) {
        this.overlayView.updateNextPrevNavigation({
          enablePrev: false,
          enableNext: false
        });
      }
    },

    _disposeContentOverlayInstance: function() {
      podioEvent.trigger(podioEvent.Types.overlayClosed, this.currentUrlPattern);
      globalEvent.trigger('overlay.close');

      this.overlayView.dispose();
      delete this.currentOverlayOptions;
      delete this.overlayView;
    },

    _restoreTitle: function() {
      if (_.isUndefined(this.prevDocumentTitle)) {
        return;
      }

      document.title = this.prevDocumentTitle;
      delete this.prevDocumentTitle;
    },

    closeOverlay: function() {
      this.onOverlayClosed();
    },

    onOverlayClosing: function() {
      if (_.isFunction(this.shouldClose)) {
        var dfd = this.shouldClose();

        if (this.currentExports.animateClosing) {
          dfd = dfd.then(this.currentExports.animateClosing);
        }

        dfd.done(this.onOverlayClosed);
      } else {
        this.onOverlayClosed();
      }
    },

    onOverlayClosed: function() {
      if (!_.isUndefined(this.returnURL)) {
        this.navigator.navigateTo(this.returnURL);
      }
    },

    onOverlayPrevNextTriggered: function(direction) {
      var options = this.currentOverlayOptions;
      var animation, loadFunc;

      if (this.animationDfd && this.animationDfd.state() === 'pending') {
        return;
      }

      if (direction === 'prev') {
        loadFunc = 'loadPrev';
        animation = this.ANIMATION_TYPES.shiftRight;
      } else {
        loadFunc = 'loadNext';
        animation = this.ANIMATION_TYPES.shiftLeft;
      }

      if (!options.itemNavigationDelegate.isNextItemAvailable()) {
        this.overlayView.displayLoaderOnArrow('next');
      }

      // defer so the animated gif is displayed properly
      _.defer(function() {
        options.itemNavigationDelegate[loadFunc]().done(function(model) {
          this.overlayView.removeLoaderFromArrow('next');
          this.navigateToContent(animation, model);
        }.bind(this));
      }.bind(this));
    },

    navigateToContent: function(animation, model) {
      if (_.isFunction(this.currentExports.animate) && !browser.msie) {
        this.animationDfd = this.currentExports.animate(animation);

        this.animationDfd.done(function() {
          this.currentExports.navigate(model.get('link'));
        }.bind(this));
      } else {
        this.currentExports.navigate(model.get('link'));
      }
    },

    localNavigate: function(url, options) {
      var self = this;
      var dfd = new $.Deferred();

      if (typeof this.shouldClose === 'function') {
        dfd = this.shouldClose();
      } else {
        dfd.resolve();
      }

      return dfd.done(function() {
        if (self.currentExports && self.currentExports.navigate) {
          self.currentExports.navigate(url, { handlerOptions: options });
        } else {
          history.pushState({ dynamic: true }, '', url);
        }
      });
    },

    isOnPermalink: function() {
      return this.contentOptions.permalink;
    },

    hasContent: function() {
      return this.currentBundle;
    }
  }, {
    /**
     * A little singleton
     */
    getInstance: function() {
      var instance;

      return function(options) {
        if (_.isUndefined(instance)) {
          instance = new controller(options);
        } else if (_.isDefined(options)) {
          instance._initOptions(options);
        }

        return instance;
      };
    }()
  });

  // Mixin the statemachine
  _.extend(controller.prototype, BackboneMixinStateMachine);

  return controller;

});

